import { createFileRoute } from '@tanstack/react-router'
import { InboxesPage } from '@/pages/inboxes'

export const Route = createFileRoute('/_authenticated/inboxes')({
  component: InboxesPage,
})
